// extracted by mini-css-extract-plugin
module.exports = {"icon":"SocialIcons_icon__k_hUq"};